// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__UXUQR","appBody":"App_appBody__2UTur","content":"App_content__1xhtt","absoluteContent":"App_absoluteContent__ogu7W","link":"App_link__3FMn3"};